<template>
  <div class="main">
    <layout />
    <TopbgVue :title="title" />
    <div class="list">
      <div class="item-title">{{ title }}</div>
      <div class="ul">
        <div @click="toDetail(item)" class="li" v-for="(item, index) in listData" :key="index">
          <div class="li-title">{{ item.title }}</div>
          <div class="li-text">{{ item.time }}</div>
          <div class="li-text">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopbgVue from "./Topbg.vue";
import Footer from './footer.vue';
import Layout from './Layout.vue';
export default {
  data() {
    return {
      name:'Lifeservices',
      title: "生活服务",
      listData:[{
        title:'百叶窗-电动百叶窗-遮光百叶窗',
        time:'24-01-01',
        text:'遮阳-我们是认真的！（同等质量比价格，同等价格比质​‌‌量）南宁天马智能遮阳科技有限公司，成立于2001年，我们以完美的产品质量，完美的售后服务来赢得客户的信任和支持。本公司专业加工批发、销售电动遥控卷帘、电动开台帘、电动天棚帘、电动百叶窗帘、手动卷帘、百叶窗帘、竹木卷帘、推拉帘、百折帘、装饰布帘、隐形纱窗、冬夏门帘。天马拥有专业的成品组装生产线、安装施工团队、及完善的售后服务团队，使我们与各大门窗厂、房地产公司、装饰公司等建立了长期的供货合作关系。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌'
      },{
        title:'邕宁年桔，年宵花，草花，绿植租摆',
        time:'24-01-01',
        text:'南宁市香草物语花卉场，专业租摆植物花卉装饰酒店、宾​‌‌馆、办公写字楼、行政机关、购物中心、休闲中心等场所。香草物语坐落于绿城南宁，花卉四季品种多样，种养结合，品种齐全。外地采购品种经本地驯养后再租售，确保了植物的生长状态健康美观。公司与昆明、广州、番禺、深圳、漳州等地的园艺公司及大型花木基地签订长期合作协议，确保采购花卉的品质。经过严格培训的业务人员为您的环境量身定制特色的租摆方案。专业的养护人员定期对花卉进行护理、五星级的养护标准及严格的管理流程为您创造清新干净的办公和家居环境。采用世界优质园艺肥料，澳大利亚澳沃肥料公司生产的巨能神肥水溶性肥料及高级长效控释肥奥绿肥进行养护，无色，无虫，植物生长健康、姿态优美、花叶亮丽。完善的物流配送系统，保证了服务快捷，响应及时。风格各异的盆器、变化多端的艺术组合盆栽，更贴切地融入您的房屋格局、家具及装修风格，使您的办公环境达到更加和谐的艺术美感。规模化的经营确保在同等摆放植物档次情况下，同等价格水平下植物档次高。服务内容：1.出租盆花、盆景、观叶植物，能够提供套盆、套缸、花几、支架、奇石、根雕、水托、仿真花、饰品等园艺附属物品。2.保证所提供的盆栽植株健壮、长势良好并且形态优美、造型优美。3.负责运输，送货上门；租摆到位，定期养护。4.及时更换，保证观赏效果。5.可根据用户要求，进行特殊设计和布置。五、植物租赁服务细则1.植物造形美观，摆放合理，叶色自然。2.清洁卫生，叶面无尘土，无病虫害，盆土无异味。3.及时更换不符合租摆标准的植物。4.园林技工提供“星级”技术跟踪养护服务，每月到场养护4—8次，包括浇水、施肥、虫害防治、保花、保叶、植物更新等工作，园林技工认真负责按植物需要适时进行护理工作，遵守租用方规章制度不得防碍租用方的正常工作与经营。5.定期进行质量服务检查征求租用方意见，及时解决出现问题。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌'
      },{
        title:'金属加工-南宁数控冲孔-钣金冲孔-钣金加工',
        time:'24-01-02',
        text:'南宁鑫意达激光科技有限公司，成立于2007年，是大​‌‌连地区规模较大的激光切割加工、钣金加工厂之一。具有专业的高级技术人员和一流的生产设备。公司引进国际先进的意大利激光切割机3台，以及4米、6米剪板机，折弯机多台。可现场加工各种金属和非金属板材的造型穿孔，不受模具限制，板厚可达到0.1mm-25mm。主要经营加工各类金属，不锈钢板材、管材及配件，可承揽各项白钢工程；主营业务：南宁钣金加工、南宁激光切割、南宁金属加工、南宁激光切割加工、南宁金属切割、南宁激光切割加工厂、南宁冲孔加工、数控冲孔加工、激光切割加工、南宁白钢加工、南宁不锈钢加工、南宁铁艺制作、激光切割加工零配件等。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌​‌‌'
      },{
        title:'大骨鸡鸡苗,红公鸡苗,鸭苗,鹅苗 长期大量供',
        time:'24-01-03',
        text:'长期大量供应庄河大骨鸡,红公鸡苗，鸭苗，鹅苗,同时​‌‌​‌‌​‌‌也回收。初次养殖可以上门招导，。。有意请来考察。联系人合作社，许经理，，联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌​‌‌​‌‌'
      },{
        title:'各区均有开锁分部,24小时上门开锁',
        time:'24-01-04',
        text:'开锁公司提供开锁、换锁、修锁、换各种防盗门锁芯，防盗门锁具升级、更换各种家庭用锁、办公用锁、汽车用锁等锁具服务。服务各社区、写字楼、上门服务，经公安备案，工商注册，安全放心快捷，持有正规发票，持证上岗。本公司是经工商注册，公安备案，正规专业的开锁公司，全天24小时上门服务。多年以来专业从事锁具的装配与维修，深受广大客户的信赖及认可。服务部技术人员及管理人员都经过一年以上的专业技术及职业道德培训、严格管理、持证上岗、从言行、仪表做起，苦练过硬本领，全天24小时为您解决燃眉之急，全方位365天师傅快捷快速上门服务。价格自然公道，师傅技术专业!开锁：技术开启各种防盗门锁、内门锁、车库锁、汽车锁、密码箱、保险柜、指纹锁等锁具，技术开启，无损坏。换锁：更换各种锁具：防盗门锁、卷帘门锁、地下室门锁、抽屉锁、木门锁、室内门锁、单元门锁、文件柜锁、玻璃门锁、单位公司锁、锁芯、把手、锁体、猫眼、门铃、(防盗门锁芯B级锁芯、超B级锁芯、C级双面叶片锁芯、高档锁芯、）等更换指纹锁安装指纹密码锁。修锁：修理各种锁具：防盗门锁、地下室门锁、卷帘门锁、室内门锁、专业改装门锁。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌‌'
      }]
    };
  },
  components: {
    TopbgVue,
    Layout,
    Footer
  },
  mounted() {
    // this.title = this.$route.query.title;
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path:'/detail',
        query: {
          title: item.title,
          text: item.time,
          detail: item.text,
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.list {
  max-width: 1320px;
  margin: 80px auto 0;
  .item-title {
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #0099cc;
  }
  .ul {
    padding: 0 30px 50px 200px;
    background: #f0f8ff;
    .li {
      padding-top: 50px;
      .li-title {
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        color: #000000;
      }
      .li-text {
        padding-top: 10px;
        font-size: 16px;
        color: #717275;
      }
      .li-text:nth-child(2) {
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; /*省略几行写几*/
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>